export const ROLE_ROUTES = {
  ClientAdmin: [
    'customers',
    'inventory',
    'reports',
    'search-order',
    'commissions',
    'subscription',
    'services',
    'settings',
    'glossary',
    'faq',
    'media',
    'schedule',
    'tools',
    'training',
    'profile',
    'page',
    'admin',
  ],
  Admin: [
    'customers',
    'inventory',
    'reports',
    'search-order',
    'commissions',
    'subscription',
    'services',
    'settings',
    'glossary',
    'faq',
    'media',
    'schedule',
    'tools',
    'training',
    'profile',
    'page',
    'admin',
  ],
  CustomerService: ['customers'],
  Compliance: ['customers', 'admin'],
};
